import moment from 'moment';

// Our Angular app expects to use some libraries as globals. Shimming with webpack.ProvidePlugin
// isn't sufficient because parts of the code refer to XXX as $window.XXX
window.moment = moment;
